<div class="play-loader">
  <div class="play-loader__circle" #circle>
    <svg class="play-loader__ring" #progressContainer>
      <circle #progressCircle class="play-loader__ring-inner"></circle>
    </svg>

    <app-icon icon="play" class="play-loader__icon"></app-icon>
    <div class="play-loader__label">3D</div>
  </div>
</div>